<script lang="ts" setup>
import type { TutorialVideoType } from '@/components/ui/types'

const options: {
  name: string
  value: TutorialVideoType
  icon: string
}[] = [
  {
    name: 'Bębny',
    value: 'drums',
    icon: '$tutorialDrums',
  },
  {
    name: 'Bas',
    value: 'bass_guitar',
    icon: '$tutorialGitBass',
  },
  {
    name: 'Piano',
    value: 'piano',
    icon: '$tutorialPiano',
  },
  {
    name: 'Keys',
    value: 'keys',
    icon: '$tutorialPiano',
  },
  {
    name: 'Aku',
    value: 'acoustic_guitar',
    icon: '$tutorialGitAcc',
  },
  {
    name: 'Ele',
    value: 'electric_guitar',
    icon: '$tutorialGitEle',
  },
]

const {
  size = 68,
} = defineProps<{
  size?: number
}>()

const modelValue = defineModel<TutorialVideoType>('modelValue',{
  required: true,
})
</script>

<template>
  <v-btn-toggle
    v-model="modelValue"
    class="csm-ui-tutorials-video-icons-select"
    selected-class="border-accent"
    color="primary"
    mandatory
    rounded="lg"
    :style="{
      height: `${size}px`,
      boxSizing: 'border-box',
    }"
  >
    <ui-stacked-btn
      v-for="option of options"
      :key="option.value"
      class="border-opacity-100 pa-0"
      :value="option.value"
      :text="option.name"
      :icon="option.icon"
      :border="modelValue === option.value ? 'sm' : undefined"
      :size="size"
      :active="modelValue === option.value"
    />
  </v-btn-toggle>
</template>

<style lang="scss" scoped>
.csm-ui-tutorials-video-icons-select {
  position: relative;

  &::before {
    position: absolute;
    top: 0;
    left: 0;
    content: '';
    width: 100%;
    height: 100%;
    border-radius: inherit;
    border: 1px solid rgb(var(--v-theme-gray-300));
  }
}
</style>
